<template>
  <v-dialog v-model="dialog" max-width="500px">
    <v-card>
      <v-card-title>新增课程</v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-select
            v-model="formData.courseCategoryId"
            :items="courseCategories"
            item-text="name"
            item-value="id"
            label="课程目录"
            :rules="[v => !!v || '请选择课程目录']"
            required
          ></v-select>
          
          <v-text-field
            v-model="formData.topicName"
            label="课程主题名称"
            :rules="[v => !!v || '请输入课程主题名称']"
            required
          ></v-text-field>
          
          <v-file-input
            v-model="formData.coverImageFile"
            label="上传封面图"
            :rules="[v => !!v || '请选择图片文件']"
            required
            accept="image/*"
            show-size
          ></v-file-input>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="close">取消</v-btn>
        <v-btn color="blue darken-1" text @click="submit">确定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { courseApi } from '@/api/course'

export default {
  name: 'CreateCourseTopicPopup',
  data() {
    return {
      dialog: false,
      valid: false,
      formData: {
        courseCategoryId: '',
        topicName: '',
        coverImageFile: null
      },
      courseCategories: []
    }
  },
  methods: {
    open(categories) {
      this.courseCategories = categories;
      this.dialog = true;
    },
    close() {
      console.log('call close');
      this.dialog = false;
      this.$refs.form.reset();
    },
    async submit() {
      if (!this.$refs.form.validate()) return;

      try {
        const params = {
          categoryId: this.formData.courseCategoryId,
          topicName: this.formData.topicName,
          coverImageFile: this.formData.coverImageFile
        };
        
        console.log('Submitting with params:', params);
        
        const response = await courseApi.createCourseTopic(params);
        this.$emit('course-topic-created', response.data);
        this.close();
        this.$toast.success('课程主题创建成功');
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message || '未知错误';
        this.$toast.error('创建失败：' + errorMessage);
      }
    }
  }
}
</script> 